<template>
	<fieldset
		v-if="name && id && formCode && placeholder"
		class="itv-input-textarea"
	>
		<label
			v-if="label"
			class="itv-input-textarea__label"
			:for="`${id}-${formCode}`"
		>
			{{ label }}
		</label>
		<div class="itv-input-textarea__field-wrap">
			<textarea
				class="itv-input-textarea__field"
				:name="name"
				:id="`${id}-${formCode}`"
				:placeholder="placeholder"
				v-model="value"
				autocomplete="off"
				maxlength="300"
			></textarea>
			<div v-if="value" class="itv-input-textarea__clear">
				<btn-clear @click-event="clearField" />
			</div>
		</div>
	</fieldset>
</template>

<script>
import BtnClear from './BtnClear'

export default {
	name: 'InputTextarea',
	components: {
		BtnClear,
	},
	props: {
		placeholder: {
			type: String,
			default: '',
		},
		label: {
			type: String,
			default: '',
		},
		name: {
			type: String,
			default: '',
		},
		formCode: {
			type: String,
			default: 'form',
		},
		id: {
			type: String,
			default: 'textarea',
		},
	},
	data() {
		return {
			value: '',
		}
	},
	watch: {
		value(newValue) {
			this.$emit('changeValue', newValue, this.id)
		},
	},
	methods: {
		clearField() {
			this.value = ''
		},
	},
}
</script>
